import React, {useCallback} from "react";
import {HttpClient} from "../../http/HttpClient.jsx";
import "./google-map-address-navigator.css";

export const GoogleMapAddressNavigator = ({address, title = "פתח בגוגל מפות"}) => {
    const openAddressInNewTab = useCallback(async address => {
        const {geometry} = (await HttpClient.safeGet(`/api/location/address/${address}`)) ?? {};

        if (geometry) {
            window.open(
                `https://www.google.com/maps/place/?q=${geometry?.location?.lat},${geometry?.location?.lng}`,
                "noreferrer"
            );
        }
    }, []);

    return (
        <span className="google-address-link" onClick={() => openAddressInNewTab(address)}>
            {title}
        </span>
    );
};
